import { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { api, errorMessage } from "@/lib/api";

export const ForceMfaEnrol = () => {
  const { logout } = useAuth();
  const [setup, setSetup] = useState(null);
  const [code, setCode] = useState("");
  const start = async () => { try { setSetup((await api.post("/auth/me/mfa/setup")).data); } catch (e) { toast.error(errorMessage(e)); } };
  const enable = async () => {
    try { await api.post("/auth/me/mfa/enable", { code }); toast.success("Two-factor authentication is on"); window.location.reload(); }
    catch (e) { toast.error(errorMessage(e)); }
  };
  return (
    <div className="mx-auto max-w-md pt-10" data-testid="force-mfa-enrol">
      <Card><CardHeader><CardTitle className="flex items-center gap-2 text-lg"><ShieldCheck className="h-5 w-5 text-primary" />Set up two-factor authentication</CardTitle></CardHeader>
        <CardContent className="space-y-3 text-sm">
          <p className="text-muted-foreground">An Admin has made two-factor authentication required for your account. Set it up with an authenticator app to continue.</p>
          {!setup ? <Button className="w-full" onClick={start} data-testid="force-mfa-start">Show QR code</Button> : <>
            <img src={setup.qr_data_url} alt="Authenticator QR code" className="h-40 w-40 rounded-sm border bg-white p-2" data-testid="force-mfa-qr" />
            <p className="code-text break-all rounded-sm bg-muted px-2 py-1.5 text-xs" data-testid="force-mfa-secret">{setup.secret}</p>
            <Input value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} maxLength={6} placeholder="6-digit code" className="tabular-nums" data-testid="force-mfa-code" />
            <Button className="w-full" disabled={code.length !== 6} onClick={enable} data-testid="force-mfa-enable">Turn on</Button></>}
          <Button variant="ghost" className="w-full" onClick={logout} data-testid="force-mfa-logout">Sign out</Button>
        </CardContent></Card>
    </div>
  );
};
